import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Row, Typography, CircularLoader, CloseButton, useOverlayContext, ConfirmationModal, Column, IconButton } from 'seagull';
import { Download } from 'seagull/icons';
import { useStore } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { selectors } from '~/store/state-selectors';
import { formatFileSize } from '~/utils/fileSize.utils';
import { AttachmentsTestIds } from './Attachments.utils';
export const AttachmentFile = (param)=>{
    let { file, index, onRemove, disableDownloadLink = false } = param;
    const { t: texts } = useLocaleKeys('components.attachmentFile');
    const { t: commonTexts } = useLocaleKeys('common');
    const isVendor = useStore(selectors.user.isVendor);
    const overlayContext = useOverlayContext();
    const handleRemove = ()=>{
        overlayContext.showModal({
            closeOnClickOutside: true,
            closeOnEscapeKey: true,
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(ConfirmationModal, {
                    skin: "danger",
                    title: texts.removeFile(),
                    content: /*#__PURE__*/ _jsxs(Column, {
                        gap: 8,
                        children: [
                            /*#__PURE__*/ _jsx(Typography, {
                                align: "left",
                                children: texts.confirmRemoveContent({
                                    fileName: file.displayName
                                })
                            }),
                            /*#__PURE__*/ _jsx(Typography, {
                                align: "left",
                                children: texts.fileNoLongerAccessible()
                            })
                        ]
                    }),
                    primaryButtonLabel: commonTexts.buttons.removeFile(),
                    secondaryButtonLabel: commonTexts.buttons.cancel(),
                    onPrimaryButtonClick: ()=>{
                        onRemove(index);
                        dismissModal();
                    },
                    onSecondaryButtonClick: ()=>dismissModal(),
                    onCloseButtonClick: ()=>dismissModal()
                });
            }
        });
    };
    return /*#__PURE__*/ _jsxs(Row, {
        gap: 4,
        alignItems: "center",
        children: [
            /*#__PURE__*/ _jsx(FileName, {
                disableDownloadLink: disableDownloadLink,
                file: file
            }),
            /*#__PURE__*/ _jsx(FileSize, {
                file: file
            }),
            file.loading ? /*#__PURE__*/ _jsx(CircularLoader, {
                testId: AttachmentsTestIds.FileLoader(index),
                size: 16
            }) : isVendor ? /*#__PURE__*/ _jsx(CloseButton, {
                skin: "transparent",
                size: "small",
                onClick: handleRemove,
                testId: AttachmentsTestIds.RemoveButton(index)
            }) : !disableDownloadLink && /*#__PURE__*/ _jsx(DownloadButton, {
                file: file,
                index: index
            })
        ]
    }, file.displayName);
};
const FileName = (param)=>{
    let { file: { url, displayName: name }, disableDownloadLink } = param;
    return /*#__PURE__*/ _jsx(Typography, {
        as: disableDownloadLink ? 'div' : 'a',
        variant: "paragraph1",
        href: disableDownloadLink ? undefined : url,
        testId: AttachmentsTestIds.File(name),
        children: name
    });
};
const FileSize = (param)=>{
    let { file: { displayName: name, fileSize: size } } = param;
    return /*#__PURE__*/ _jsx(Typography, {
        skin: "secondary",
        variant: "paragraph1",
        testId: AttachmentsTestIds.FileSize(name),
        children: "(".concat(formatFileSize(size), ")")
    });
};
const DownloadButton = (param)=>{
    let { file, index } = param;
    return /*#__PURE__*/ _jsx(IconButton, {
        noPadding: true,
        skin: "transparent",
        size: "xsmall",
        testId: AttachmentsTestIds.DownloadIcon(index),
        onClick: ()=>file.url && window.open(file.url, '_self'),
        children: /*#__PURE__*/ _jsx(Download, {
            size: 16
        })
    });
};
